import AvailableSlots from '@features/applicant/components/AvailableSlots/AvailableSlots';
import WithdrawApplication from '@features/applicant/components/WithdrawApplication/WithdrawApplication';
import { Application } from '@features/applications';
import { UserEvent } from '@features/events';
import MessagingModal from '@features/messaging/components/MessagingModal/MessagingModal';
import { getTimeZoneAbbreviation } from '@features/profile';
import {
  CalendarMonth,
  AccessTime,
  Close,
  WorkOutline,
} from '@mui/icons-material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { Dispatch, FC, SetStateAction, useContext, useState } from 'react';

import { OpenInterview } from '../../../../vectors/index';

type ApplicantEventInfoModalProps = {
  event: UserEvent | null;
  handleClose: () => void;
  setSelectedApplication?: Dispatch<SetStateAction<Application | null>>;
  selectedApplication?: Application | null;
  application?: Application;
};

const ApplicantEventInfoModal: FC<ApplicantEventInfoModalProps> = ({
  event,
  handleClose,
}) => {
  const browserTimeZone = getTimeZoneAbbreviation();
  const [isMessagingModalOpen, setIsMessagingModalOpen] = useState(false);
  const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
  const [isScheduledInterviewModalOpen, setIsScheduledInterviewModalOpen] =
    useState(false);

  const renderScheduledDetail = (event: any) => (
    <>
      <Typography
        component="span"
        variant="body1"
        sx={{
          display: 'flex',
          alignItems: 'center',
          maxWidth: '190px',
          width: '100%',
          alignSelf: 'center',
        }}
      >
        <CalendarMonth fontSize="medium" sx={{ mr: 2 }} />
        {dayjs(
          event.type === 'block'
            ? event.block_start_date
            : event?.dt_start_time,
        ).format('MMM DD, YYYY')}
      </Typography>
      <Typography
        component="span"
        variant="body1"
        sx={{
          display: 'flex',
          alignItems: 'center',
          maxWidth: '204px',
          width: '100%',
          alignSelf: 'center',
        }}
      >
        <AccessTime fontSize="medium" sx={{ mr: 2 }} />
        {`${dayjs(event?.dt_start_time).format('hh:mm')} - ${dayjs(event?.dt_end_time).format('hh:mm a')} ${browserTimeZone || ''}`}
      </Typography>

      <Typography
        component="span"
        variant="body1"
        sx={{
          display: 'flex',
          alignItems: 'center',
          margin: '20px 0 !important',
          width: '100%',
        }}
      >
        <WorkOutline fontSize="medium" sx={{ mr: 2 }} />
        <strong style={{ marginRight: '10px' }}>Position:</strong>{' '}
        {event?.application.position}
      </Typography>
    </>
  );

  if (!event) {
    return null;
  }

  console.log('event?.application___', event?.application?.calendar_item);

  // const companyInfo = event?.application?.calendar_item?.company;
  const companyInfo = event?.company;
  const physical_address_concate =
    companyInfo?.additional_info?.physical_interview_location ||
    `${companyInfo?.s_address1 || companyInfo?.s_address2 || ''} ${companyInfo?.s_city || ''} ${companyInfo?.s_state || ''} ${companyInfo?.s_zip || ''}`.trim();

  const block_companyInfo = event?.application?.calendar_block_invite?.company;

  const block_physical_address_concate =
    block_companyInfo?.additional_info?.physical_interview_location ||
    `${block_companyInfo?.s_address1 || block_companyInfo?.s_address2 || ''} ${block_companyInfo?.s_city || ''} ${block_companyInfo?.s_state || ''} ${block_companyInfo?.s_zip || ''}`.trim();

  return (
    <>
      <Dialog open onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>
          <IconButton
            sx={{ position: 'absolute', top: 5, right: 5 }}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
          <br />
          {event?.company?.s_logo_file ? (
            <Avatar
              src={event?.company?.s_logo_file || ''}
              style={{
                width: '60px',
                height: '60px',
                marginRight: '12px',
                borderRadius: 5,
                textAlign: 'center',
                alignSelf: 'center',
                margin: '0 auto',
              }}
            />
          ) : (
            <OpenInterview />
          )}

          <Typography variant="h4" sx={{ pt: 3 }}>
            Scheduled Interview at <br /> <b>{event?.company.s_name}</b>
          </Typography>
          <Typography>
            {event?.company?.s_address1}, {event?.company?.s_city}{' '}
            {event?.company?.s_state}, {event?.company?.s_zip}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="h4" mb={2}>
            Interview Details:
          </Typography>

          <Box mb={3}>
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                pl: '5px',
                width: '100%',
              }}
              textAlign="center"
              alignSelf="center"
            >
              <strong>Interview type :</strong>
              <span style={{ marginLeft: '4px' }}>
                {(event &&
                  event?.application?.calendar_item?.block_type === 1) ||
                event?.block_type === 1 ||
                event?.application?.calendar_block_invite?.block?.block_type ==
                  1
                  ? 'In Person'
                  : 'Virtual'}
              </span>
            </Typography>

            {(event && event?.application?.calendar_item?.block_type === 1) ||
            event?.block_type === 1 ||
            event?.application?.calendar_block_invite?.block?.block_type ==
              1 ? (
              // <Typography
              //   sx={{
              //     display: 'flex',
              //     alignItems: 'center',
              //     marginTop: '4px',
              //     width: '100%',
              //   }}
              //   textAlign="center"
              //   alignSelf="center"
              // >
              //   <LocationOnOutlinedIcon
              //     fontSize="medium"
              //     sx={{ mr: 0, color: 'black' }}
              //   />

              //   <span style={{ paddingLeft: '10px' }}>
              //     {/* {event?.application?.calendar_item?.company?.additional_info
              //       ?.physical_interview_location
              //       ? event?.application.calendar_item?.company?.additional_info
              //           ?.physical_interview_location
              //       : event?.company?.additional_info
              //             ?.physical_interview_location
              //         ? event?.company?.additional_info
              //             ?.physical_interview_location
              //         : event?.application?.calendar_block_invite?.company
              //             ?.additional_info?.physical_interview_location} */}

              //     {physical_address_concate
              //       ? physical_address_concate
              //       : block_physical_address_concate}
              //       fdsfdsflkskfjklasfklasfjkldasjklfdsfkjsldkfjklsklalfdgjkdf
              //   </span>
              // </Typography>

              <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
                <LocationOnOutlinedIcon
                  fontSize="medium"
                  sx={{ color: 'black', mt: '2px' }}
                />

                <Box
                  sx={{
                    pl: 1,
                    flex: 1,
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }}
                >
                  {physical_address_concate || block_physical_address_concate}
                </Box>
              </Box>
            ) : (
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '4px',
                  width: '100%',
                }}
                textAlign="center"
                alignSelf="center"
              >
                <VideocamOutlinedIcon
                  sx={{ color: 'black' }}
                  fontSize="medium"
                />

                <a
                  style={{ paddingLeft: '5px', textDecoration: 'none' }}
                  target="_blank"
                  href={
                    event?.application?.calendar_item?.company?.additional_info
                      ?.virtual_interview_link ||
                    event?.company?.additional_info?.virtual_interview_link ||
                    event?.application?.calendar_block_invite?.company
                      ?.additional_info?.virtual_interview_link
                  }
                  rel="noreferrer"
                >
                  Join meeting
                </a>
              </Typography>
            )}
          </Box>

          <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            mb={2}
            mt={2}
          >
            {renderScheduledDetail(event as any)}
          </Stack>

          <Stack
            spacing={2}
            sx={{ width: '100%' }}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              variant="contained"
              fullWidth
              size="small"
              onClick={() => setIsMessagingModalOpen(true)}
            >
              Message
            </Button>
            {event?.type === 'block' &&
              (() => {
                const interviewTime = dayjs(event?.dt_start_time);
                const now = dayjs();
                const isWithinTwoHours =
                  interviewTime.diff(now, 'minute') <= 120;

                return (
                  <Tooltip
                    title={
                      isWithinTwoHours
                        ? 'It’s too close to your scheduled interview time to adjust this interview. Please message the employer directly to reschedule.'
                        : ''
                    }
                    placement="top"
                    arrow
                    disableHoverListener={!isWithinTwoHours}
                  >
                    <span style={{ width: '100%' }}>
                      <Button
                        variant="contained"
                        color="success"
                        fullWidth
                        size="small"
                        onClick={() => setIsScheduledInterviewModalOpen(true)}
                        disabled={isWithinTwoHours}
                      >
                        Adjust Interview Time
                      </Button>
                    </span>
                  </Tooltip>
                );
              })()}
            <Button
              variant="contained"
              color="error"
              fullWidth
              onClick={() => setIsWithdrawModalOpen(true)}
              size="small"
              aria-label="test"
              sx={{ marginBottom: '10px !important' }}
            >
              Withdraw Application
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      <MessagingModal
        isOpen={isMessagingModalOpen}
        handleClose={() => setIsMessagingModalOpen(false)}
        application={event?.application}
      />

      {isWithdrawModalOpen && (
        <WithdrawApplication
          isOpen={isWithdrawModalOpen}
          handleClose={() => {
            setIsWithdrawModalOpen(false);
            handleClose();
          }}
          applicationId={event?.application.id}
          applicationName={event?.application?.job_listing?.s_title}
        />
      )}
      {isScheduledInterviewModalOpen && (
        <AvailableSlots
          isOpen={isScheduledInterviewModalOpen}
          handleClose={() => {
            setIsScheduledInterviewModalOpen(false);
            handleClose();
          }}
          application={event?.application}
          selectedSlot={{
            blockId: event?.application?.calendar_block_invite?.block?.id,
            isSlot: !!event?.application?.calendar_block_invite?.slot,
            slotId: event?.application?.calendar_block_invite?.slot?.id ?? null,
          }}
        />
      )}
    </>
  );
};

export default ApplicantEventInfoModal;
